import React from 'react';
import {connect} from 'react-redux';
import './styles.scss';
import {compose} from 'redux';
import * as fonts from '../../../../util/fonts';

import {strings} from '../../../../util/strings';
import {
  addToGlobalStyles,
  addToWizard,
  setWizard,
} from '../../../../store/actions';
import {Column, Row} from '../../../../components/layout';
import colors from '../../../../util/colors';
import Icon from '../../../../components/icon';
import {Icons} from '../../../../util/icons';
import AppWrapper from '../../../../components/app-wrapper';
import ContainerDocumentDownload from './../../../../components/container-document-download/index';
import {Link, useHistory} from 'react-router-dom';
import moment from 'moment';

interface PreAuthorizationRequestSucessProps {
  labels: typeof strings.pt.preAuthorizations;
  wizard: any;
  setWizard: any;
  buStyles: any;
}

function PreAuthorizationRequestSucess({
  labels,
  wizard,
  setWizard,
  buStyles
}: PreAuthorizationRequestSucessProps) {
  const history = useHistory();

  if (!!!history.location.state) {
    history.push('/pre-autorizacoes');
  }

  return (
    <>
      <Column>
        <Row className="justify-content-center mb-0">
          <p
            className="m-0"
            style={{...fonts.L, ...fonts.Bold, color: colors.black}}>
            {labels?.authorization_requestOfPreAuthorization}
          </p>
          <Link
            onClick={() => {
              setWizard({});
              history.push('/pre-autorizacoes');
            }}
            to="/pre-autorizacoes"
            className="exit-label-sucess"
            style={{
              ...fonts.SM,
              ...fonts.SemiBold,
              color: buStyles?.primaryColor || colors.fluorescentBlue,
            }}>
            {labels?.authorization_close}
            <Icon
              className="svg-close-button inline-svg-close-button"
              name={Icons.CLOSE}
              width={'12'}
              height={'12'}
              changeViewbox={true}
              strokeWidth={'0.5'}
            />
          </Link>
        </Row>
        <Row className="justify-content-center mb-0">
          <p
            className="response-in-72h m-0"
            style={{...fonts.M, color: colors.black}}>
            {labels?.authorization_responseIn72hours}
          </p>
        </Row>
        <Row className="justify-content-center mb-0">
          <Icon
            name={Icons.SUCCESS}
            width="40"
            height="60"
            changeViewbox 
            viewBox={'0 0 24 24'}
            color={colors.green}
          />
        </Row>
        <Row className="justify-content-center mb-2">
          {' '}
          <p className="m-0" style={{...fonts.ML, color: colors.black}}>
            {labels?.authorization_sendWithSucess}
          </p>
          <p
            className="hours-responsive m-0"
            style={{...fonts.ML, ...fonts.Bold, color: colors.black}}>
            {history.location.state &&
              (history.location.state as any).submissionTime}
          </p>
        </Row>
        <Row className="hours justify-content-center">
          {' '}
          <p
            className="m-0"
            style={{...fonts.ML, ...fonts.Bold, color: colors.black}}>
            {history.location.state &&
              (history.location.state as any).submissionTime}
          </p>
        </Row>
        <Row className="pre-authorization-container-sucess">
          <Column className="col-2 pt-4 pl-4 pb-4 pr-0">
            <Row className="rowstest justify-content-start">
              <p className="m-0" style={{...fonts.MM, color: colors.black}}>
                {labels?.authorization_process}
              </p>
            </Row>
            <Row className="rowstest justify-content-start">
              <p className="m-0" style={{...fonts.MM, color: colors.black}}>
                {labels?.authorization_patient}:
              </p>
            </Row>
            <Row className="rowstest justify-content-start">
              <p className="m-0" style={{...fonts.MM, color: colors.black}}>
                {labels?.authorization_proceed}
              </p>
            </Row>
          </Column>
          <Column className="col-4 pt-4 pl-0 pr-0">
            <Row className="rowstest justify-content-end">
              <p
                className="right-column-responsive"
                style={{
                  ...fonts.MM,
                  ...fonts.Bold,
                  color: colors.black,
                }}>
                -
              </p>
            </Row>
            <Row className="rowstest justify-content-end">
              <p
                className="right-column-responsive"
                style={{
                  ...fonts.MM,
                  ...fonts.Bold,
                  color: colors.black,
                }}>
                {history.location.state &&
                  (history.location.state as any).patient}
              </p>
            </Row>
            <Row className="rowstest justify-content-end">
              <p
                className="right-column-responsive"
                style={{
                  ...fonts.MM,
                  ...fonts.Bold,
                  color: colors.black,
                }}>
                {' '}
                {history.location.state &&
                  (history.location.state as any).proceed}
              </p>
            </Row>
          </Column>
          <Column className="col-2 p-4 pl-2">
            <Row className="rowstest justify-content-start">
              <p
                className="labels-of-data m-0"
                style={{...fonts.MM, color: colors.black}}>
                {labels?.authorization_ocurrenceDate}
              </p>
            </Row>
            <Row className="rowstest justify-content-start">
              <p className="m-0" style={{...fonts.MM, color: colors.black}}>
                {labels?.authorization_provider}
              </p>
            </Row>
          </Column>
          <Column className="col-4 p-4 pl-2">
            <Row className="rowstest justify-content-end">
              <p
                className="right-column-responsive"
                style={{
                  ...fonts.MM,
                  ...fonts.Bold,
                  color: colors.black,
                }}>
                {history.location.state &&
                  (history.location.state as any).date &&
                  moment((history.location.state as any).date).format(
                    'DD-MM-YYYY'
                  )}
              </p>
            </Row>
            <Row className="rowstest justify-content-end">
              <p
                className="right-column-responsive"
                style={{
                  ...fonts.MM,
                  ...fonts.Bold,
                  color: colors.black,
                }}>
                -
              </p>
            </Row>
          </Column>
        </Row>

        <Row className="pre-authorization-container-sucess-responsive">
          <Column className="col-4 pt-4 pr-0">
            <Row className="rowstest justify-content-start">
              <p className="m-0" style={{...fonts.SM, color: colors.black}}>
                {labels?.authorization_process}
              </p>
            </Row>
            <Row className="rowstest justify-content-start">
              <p className="m-0" style={{...fonts.SM, color: colors.black}}>
                {labels?.authorization_patient}:
              </p>
            </Row>
            <Row className="rowstest justify-content-start">
              <p className="m-0" style={{...fonts.SM, color: colors.black}}>
                {labels?.authorization_proceed}
              </p>
            </Row>
            <Row className="rowstest date-of-occurence-responsive-row">
              <p
                className="date-of-occurence-responsive m-0"
                style={{...fonts.SM, color: colors.black}}>
                {labels?.authorization_ocurrenceDate}
              </p>
            </Row>
            <Row className="rowstest justify-content-start">
              <p className="m-0" style={{...fonts.SM, color: colors.black}}>
                {labels?.authorization_provider}
              </p>
            </Row>
          </Column>
          <Column className="col-8 pt-4 pl-0">
            <Row className="rowstest justify-content-end">
              <p
                className="right-column-responsive mb-0"
                style={{...fonts.SM, ...fonts.Bold, color: colors.black}}>
                -
              </p>
            </Row>
            <Row className="rowstest justify-content-end">
              <p
                className="right-column-responsive mb-0"
                style={{...fonts.SM, ...fonts.Bold, color: colors.black}}>
                {history.location.state &&
                  (history.location.state as any).patient}
              </p>
            </Row>
            <Row className="rowstest justify-content-end">
              <p
                className="right-column-responsive mb-0"
                style={{...fonts.SM, ...fonts.Bold, color: colors.black}}>
                {history.location.state &&
                  (history.location.state as any).proceed}
              </p>
            </Row>
            <Row className="rowstest justify-content-end">
              <p
                className="right-column-responsive mb-0"
                style={{...fonts.SM, ...fonts.Bold, color: colors.black}}>
                {history.location.state &&
                  (history.location.state as any).date &&
                  moment((history.location.state as any).date).format(
                    'DD-MM-YYYY'
                  )}
              </p>
            </Row>
            <Row className="rowstest justify-content-end">
              <p
                className="right-column-responsive justify-content-end mb-0"
                style={{...fonts.SM, ...fonts.Bold, color: colors.black}}>
                -
              </p>
            </Row>
          </Column>
        </Row>
        <Row className="pre-authorization-container-documents">
          <ContainerDocumentDownload
            submittedFiles={wizard.attachFiles.files}
            isNotDownloadable={true}
            title={
              labels?.preAuthorizations_attachedDocuments
            }></ContainerDocumentDownload>
        </Row>
        <Row className="exit-label-responsive">
          <Link
            onClick={() => {
              setWizard({});
            }}
            to="/pre-autorizacoes"
            style={{
              ...fonts.SM,
              ...fonts.SemiBold,
              color: colors.fluorescentBlue,
            }}>
            {labels?.authorization_close}
            <Icon
              className="svg-close-button inline-svg-close-button"
              name={Icons.CLOSE}
              width={'12'}
              height={'12'}
              changeViewbox={true}
              strokeWidth={'0.5'}
            />
          </Link>
        </Row>
      </Column>
    </>
  );
}

const mapStateToProps = ({selectedBu, user, strings, wizard, globalStyles}: any) => ({
  user,
  selectedBu,
  labels: strings.value.pt.preAuthorizations,
  wizard: wizard.value,
  buStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(PreAuthorizationRequestSucess)
);
